import { Fragment, useState } from 'react';

import ListCards from '../ListCards/ListCards';
import ListItems from '../ListItems/ListItems';
import Pagination from '../../Pagination/Pagination';
import CheckboxLabel from '../../inputs/Checkboxes/CheckboxLabel/CheckboxLabel';
import Button from '../../Buttons/Button/Button';
import FilterOrder from '../FilterOrder/FilterOrder';
import { tableViews } from '../../../services/hooks/UI/useTable';
import { ReactComponent as TwoRows } from '../../../assets/icons/TwoRows.svg';
import { ReactComponent as FourSquares } from '../../../assets/icons/FourSquares.svg';
import { ReactComponent as NotInvoicesX } from '../../../assets/icons/NotInvoicesX.svg';
import { ReactComponent as TwoSliderOrderFilter } from '../../../assets/icons/TwoSliderOrderFilter.svg';
import FiltersChips from './FiltersChips/FiltersChips';
import Sheet from '../../Sheet/Sheet';

import classes from './TableListCards.module.scss';
import NoItems from '../../NoItems/NoItems';

const ChangeViewButton = ({ Icon, label, selected, onClick }) => {
  const containerClasses = [classes['change-view'], 'pointer'];
  selected && containerClasses.push(classes['change-view--selected']);

  return (
    <button key={label} className={containerClasses.join(' ')} onClick={onClick}>
      <Icon />
      <span className='semibold-16'>{label}</span>
    </button>
  );
};

const TableListCards = ({
  table,
  className,
  columns,
  customColumns,
  itemCard,
  headerAction,
  actions,
  showCheckbox = true,
  pagination,
  isShowViewsOptions = true,
  orderOptions,
  filterOptions,
  filterOptionsGrouped,
  emptyItems,
  numberColumns = 2,
  filterChecbox,
  useWideCards = false,
  useClientCards = false,
  useSuppliersCards = false
}) => {
  const [tableView, setTableView] = useState(itemCard ? tableViews.CARDS : tableViews.LIST);
  const [showFilterOrder, setShowFilterOrder] = useState(false);

  const {
    allItemsSelected,
    allItemsSelectedHandler,
    changeItemSelectedHandler,
    items,
    limit,
    setLimit,
    orderValue,
    changeOrderValueHandler,
    filterValues,
    filterGroupedValues,
    changeFilterValues,
    changeFilterGroupedValues
  } = table;

  const containerClasses = [classes.container];
  className && containerClasses.push(className);

  const limitChangeHandler = ({ value }) => setLimit(value);

  const toggleShowFilterOrderHandler = () => setShowFilterOrder(prev => !prev);

  const cleanFiltersHander = filterKey => {
    changeFilterValues(typeof filterKey === 'string' ? filterValues.filter(value => value !== filterKey) : []);
    if (typeof filterKey !== 'string') {
      Object.keys(filterGroupedValues).forEach(key => changeFilterGroupedValues(key, 'all'));
    }
  };

  return (
    <>
      <div className={containerClasses.join(' ')}>
        <div className={classes['sub-header']}>
          <Button
            key='orderAndFilter'
            className={classes['sub-header__order-filter-btn--mobile']}
            custom='secondary'
            color='gray'
            onClick={toggleShowFilterOrderHandler}
            Icon={TwoSliderOrderFilter}
            size='md'
          />

          {showCheckbox && (
            <CheckboxLabel
              className={`semibold-16 ${classes['sub-header__checkbox']}`}
              label={
                <>
                  <span className={classes['sub-header__checkbox--web']}>Seleccionar todo</span>
                  <span className={classes['sub-header__checkbox--mobile']}>Todo</span>
                </>
              }
              checked={allItemsSelected}
              onClick={allItemsSelectedHandler}
            />
          )}
          {actions && <div className={classes['sub-header__actions']}>{actions}</div>}

          {itemCard && isShowViewsOptions && (
            <div className={classes['sub-header__show-as']}>
              <span className={`semibold-16 ${classes['sub-header__label']}`}>Mostrar como</span>

              <ChangeViewButton
                Icon={TwoRows}
                label='Lista'
                selected={tableView === tableViews.LIST}
                onClick={() => setTableView(tableViews.LIST)}
              />

              <ChangeViewButton
                Icon={FourSquares}
                label='Tarjetas'
                selected={tableView === tableViews.CARDS}
                onClick={() => setTableView(tableViews.CARDS)}
              />
            </div>
          )}

          {(filterOptions || filterOptionsGrouped || orderOptions) && (
            <Fragment>
              {showFilterOrder && (
                <div className={classes['sub-header__order-filter-backdrop']} onClick={toggleShowFilterOrderHandler} />
              )}
              <div className={classes['sub-header__order-filter']}>
                <Button
                  key='filter'
                  custom='secondary'
                  color='gray'
                  onClick={toggleShowFilterOrderHandler}
                  Icon={TwoSliderOrderFilter}
                  size='md'
                  selected={showFilterOrder}>
                  Filtrar y ordenar
                </Button>
                {showFilterOrder && (
                  <div className={classes['sub-header__order-filter-wrap']}>
                    <FilterOrder
                      orderOptions={orderOptions}
                      orderValue={orderValue}
                      changeOrderValueHandler={changeOrderValueHandler}
                      filterOptions={filterOptions}
                      filterOptionsGrouped={filterOptionsGrouped}
                      filterValues={filterValues}
                      filterGroupedValues={filterGroupedValues}
                      changeFilterValues={changeFilterValues}
                      changeFilterGroupedValues={changeFilterGroupedValues}
                    />
                  </div>
                )}
              </div>
            </Fragment>
          )}

          {headerAction && <div className={classes['sub-header__action--desktop']}>{headerAction}</div>}

          <div className={classes['sub-header__action--mobile']}>{headerAction}</div>
        </div>

        {showCheckbox && actions && <div className={classes['actions-mobile']}>{actions}</div>}

        {(filterValues.length > 0 || Object.entries(filterGroupedValues).length > 0) && (
          <FiltersChips
            filterOptions={filterOptions}
            filterValues={filterValues}
            filterOptionsGrouped={filterOptionsGrouped}
            filterGroupedValues={filterGroupedValues}
            cleanFiltersHander={cleanFiltersHander}
            changeFilterGroupedValues={changeFilterGroupedValues}
          />
        )}

        <div>
          <div>
            {items.length > 0 ? (
              <div className={classes['items-desktop']}>
                {tableView === tableViews.CARDS && itemCard && (
                  <ListCards
                    numberColumns={numberColumns}
                    items={items}
                    showCheckbox={showCheckbox}
                    onCheck={changeItemSelectedHandler}
                    itemCard={itemCard}
                    filterChecbox={filterChecbox}
                    useWideCards={useWideCards}
                    useClientCards={useClientCards}
                    useSuppliersCards={useSuppliersCards}
                  />
                )}
                {(tableView === tableViews.LIST || !itemCard) && (
                  <ListItems
                    columns={columns}
                    items={items}
                    customColumns={customColumns}
                    showCheckbox={showCheckbox}
                    onCheck={changeItemSelectedHandler}
                  />
                )}
              </div>
            ) : (
              emptyItems || <NoItems Icon={NotInvoicesX} title='No hay elementos para mostrar.' />
            )}
          </div>

          {pagination && (
            <div className={classes.pagination}>
              <Pagination
                pages={pagination.totalPages}
                current={pagination.currentPage}
                showNext={pagination.existsNextPage}
                onPrevious={() => pagination.editCurrentPage(-1)}
                onNext={() => pagination.editCurrentPage(1)}
                onPage={page => pagination.setCurrentPage(page)}
                limit={limit}
                onLimit={limitChangeHandler}
              />
            </div>
          )}
        </div>
      </div>

      {showFilterOrder && (
        <Sheet closeHandler={toggleShowFilterOrderHandler}>
          <FilterOrder
            orderOptions={orderOptions}
            orderValue={orderValue}
            changeOrderValueHandler={changeOrderValueHandler}
            filterOptions={filterOptions}
            filterValues={filterValues}
            filterGroupedValues={filterGroupedValues}
            changeFilterValues={changeFilterValues}
            changeFilterGroupedValues={changeFilterGroupedValues}
          />
        </Sheet>
      )}
    </>
  );
};

export default TableListCards;
